module.exports = __webpack_public_path__ + "static/media/Contratto fornitori.f642b0eb.pdf";